module.exports = __webpack_public_path__ + "img/20190531162645731.5defc991.png";